import { atom } from 'jotai';
import { User as FrontEggUser } from '@frontegg/redux-store/auth/interfaces';
import { getForesightStore } from '../../util/jotai-store';

// Prefer using useCurrentUser hook, this hook should only be used when auth
// information is required.
export const authenticatedUserState = atom<FrontEggUser | undefined>(undefined);

export const sessionExpiredState = atom<boolean>(false);

/** The customer tenant this host belongs to, once the account switcher has
 *  resolved it. The assistant is shared across customers and routes by this
 *  value, so a parent-account user reaches the customer they are working in
 *  rather than the token's own tenant. */
export const customerTenantIdState = atom<string | undefined>(undefined);

/** Reads the customer tenant outside React, for request interceptors and the
 *  chat socket. */
export function readCustomerTenantId(): string | undefined {
  return getForesightStore().get(customerTenantIdState);
}
